import { Languages } from 'lucide-react'
import { toast } from 'sonner'
import { localeLabel, supportedLocales, useI18n } from '@/i18n/i18n'
import { profileApi } from '@/lib/api-contracts'
import { useAuthStore } from '@/stores/auth-store'
import { Select } from './ui/form-controls'
import type { Locale } from '@/types/api'

export function LanguageMenu({ persist = true, compact = false }: { persist?: boolean; compact?: boolean }) {
  const { locale, setLocale, t } = useI18n()
  const { user, updateUser } = useAuthStore()
  const change = async (next: Locale) => {
    const previous = locale
    setLocale(next)
    if (persist && user) {
      try { await profileApi.updateLanguage(next); updateUser({ preferredCulture: next }) }
      catch { setLocale(previous); toast.error(t('error.generic')) }
    }
  }
  return <div className="relative flex items-center gap-2">
    {!compact && <Languages className="size-4 text-muted" />}
    <Select aria-label={t('auth.language')} value={locale} onChange={(e) => void change(e.target.value as Locale)} className={compact ? 'h-10 w-28 border-0 bg-transparent py-0 text-xs shadow-none' : 'h-10 w-34 py-0 text-xs'}>
      {supportedLocales.map((item) => <option key={item} value={item}>{localeLabel(item)}</option>)}
    </Select>
  </div>
}
